



















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class LicenseExceedsCourseSizeConfirmationModal extends Vue {
  @Prop({ type: Function }) readonly onConfirmAndPublish!: () => void;
  @Prop({ type: Number, default: 0 }) readonly licenseSeats!: number;
  @Prop({ type: Number, default: 0 }) readonly courseSize!: number;

  closeModal() {
    this.$emit('close');
  }

  confirmAndPublish() {
    this.onConfirmAndPublish();
  }
}
